// extracted by mini-css-extract-plugin
export default {"accordionItem":"BYlRo","itemContent":"IngOY","itemHeader":"mKqMK","headerTitle":"w3UcH","icon":"_7wQ-f","plusIcon":"t4dZl","skeleton-progress":"FZxwr"};